class PricePerItem extends HTMLElement {
  constructor() {
    super();
    this.quantityInput = null;
    this.priceBreaks = [];
    this.textElement = this.querySelector(".price-per-item__text");
    this.handleUpdate = this.updatePriceDisplay.bind(this);
    this.abortController = new AbortController();
  }

  connectedCallback() {
    this.quantityInput = this.closest(".quantity__controls")?.querySelector(
      ".quantity__input"
    );
    this.parsePriceBreaks();
    this.attachListeners();
    this.updatePriceDisplay();
  }

  disconnectedCallback() {
    this.abortController.abort();

    if (this.quantityInput) {
      this.quantityInput.removeEventListener("input", this.handleUpdate);
      this.quantityInput.removeEventListener("change", this.handleUpdate);
    }
  }

  parsePriceBreaks() {
    const minQuantity = parseInt(this.dataset.minQuantity || "", 10) || 1;
    const variantPrice = this.dataset.variantPrice;
    const priceBreaksData = this.dataset.priceBreaks;

    this.priceBreaks = [];

    if (variantPrice) {
      this.priceBreaks.push({ quantity: minQuantity, price: variantPrice });
    }

    if (priceBreaksData) {
      try {
        const breaks = JSON.parse(priceBreaksData);
        breaks.forEach((priceBreak) => {
          if (priceBreak?.quantity && priceBreak?.price) {
            this.priceBreaks.push({
              quantity: parseInt(priceBreak.quantity, 10),
              price: priceBreak.price,
            });
          }
        });
      } catch (error) {
        console.warn("[price-per-item] Failed to parse price breaks", error);
      }
    }

    this.priceBreaks.sort((firstBreak, secondBreak) => {
      return secondBreak.quantity - firstBreak.quantity;
    });
  }

  attachListeners() {
    const { signal } = this.abortController;

    if (!this.quantityInput) return;

    this.quantityInput.addEventListener("input", this.handleUpdate);
    this.quantityInput.addEventListener("change", this.handleUpdate);

    document.addEventListener("cart:change", this.handleCartChange, {
      signal,
    });
  }

  handleCartChange = (event) => {
    if (!(event instanceof CustomEvent)) return;

    this.syncCartQuantity(event.detail?.cart);
    this.updatePriceDisplay();
  };

  syncCartQuantity(cartState) {
    if (this.dataset.context !== "product" || !this.quantityInput) return;

    const variantId = parseInt(this.dataset.variantId || "", 10);
    if (!variantId || !cartState?.items) {
      this.quantityInput.dataset.cartQuantity = "0";
      return;
    }

    const matchingLineItem = cartState.items.find((item) => {
      return Number(item.variant_id) === variantId;
    });

    this.quantityInput.dataset.cartQuantity = String(
      matchingLineItem?.quantity || 0
    );
  }

  getCurrentQuantity() {
    if (!this.quantityInput) return 1;

    const inputQuantity = parseInt(this.quantityInput.value || "", 10) || 1;

    if (this.dataset.context === "product") {
      const cartQuantity =
        parseInt(this.quantityInput.dataset.cartQuantity || "", 10) || 0;
      return cartQuantity + inputQuantity;
    }

    return inputQuantity;
  }

  updatePriceDisplay() {
    if (!this.textElement || !this.priceBreaks.length) return;

    const currentQuantity = this.getCurrentQuantity();
    const matchingPriceBreak =
      this.priceBreaks.find((priceBreak) => {
        return currentQuantity >= priceBreak.quantity;
      }) || this.priceBreaks[this.priceBreaks.length - 1];

    if (!matchingPriceBreak) return;

    this.textElement.textContent = `${this.dataset.atText} ${matchingPriceBreak.price}/${this.dataset.eachText}`;
  }
}

if (!customElements.get("price-per-item")) {
  customElements.define("price-per-item", PricePerItem);
}